/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import * as types from './mutation-types'
import Vue from 'vue'

export const check = ({ commit }) => {
  commit(types.CHECK)
}

export const login = ({ commit, dispatch }, token) => {
    commit(types.LOGIN, token)
}

// Only the token: services/auth/logout clears the account after leaving the page
export const logout = ({ commit }) => {
  commit(types.LOGOUT)
}

export const checkViewAs = ({ commit }) => {
  commit(types.CHECK_GROUP_VIEW)
}

export const storeViewAs = ({ commit }, group) => {
  commit(types.GROUP_VIEW, group)
}

export default {
  check,
  login,
  logout,
  storeViewAs,
  checkViewAs
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js